/**
 * @author Apoorva <apoorva.kashyap@314ecorp.com>
 * @description icon for TranscriptSideBarIcon
 */
import clsx from 'clsx';
import React from 'react';

const InteractiveSideBarIcon: React.FC<any> = (props) => {
	const { className, ...restProps } = props;
	const cn = clsx('anticon anticon-icon', className);

	return (
		<span className={cn} aria-label='Interactive icon' {...restProps}>
			<svg aria-label='Interactive icon' width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
				<path
					strokeWidth='8'
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.42578 2.84247C8.42578 2.5398 8.67115 2.29443 8.97382 2.29443H13.8991C14.2018 2.29443 14.4472 2.5398 14.4472 2.84247C14.4472 3.14515 14.2018 3.39051 13.8991 3.39051H8.97382C8.67115 3.39051 8.42578 3.14515 8.42578 2.84247Z'
					fill='currentColor'
				/>
				<path
					strokeWidth='8'
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.42578 5.76825C8.42578 5.46558 8.67115 5.22021 8.97382 5.22021H12.6938C12.9965 5.22021 13.2418 5.46558 13.2418 5.76825C13.2418 6.07093 12.9965 6.31629 12.6938 6.31629H8.97382C8.67115 6.31629 8.42578 6.07093 8.42578 5.76825Z'
					fill='currentColor'
				/>
				<path
					strokeWidth='8'
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.42419 10.2287C8.42615 9.92602 8.67309 9.68225 8.97576 9.68421L14.4667 9.71975C14.7694 9.72171 15.0131 9.96865 15.0112 10.2713C15.0092 10.574 14.7623 10.8178 14.4596 10.8158L8.96867 10.7803C8.666 10.7783 8.42223 10.5314 8.42419 10.2287Z'
					fill='currentColor'
				/>
				<path
					strokeWidth='8'
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.42578 13.2087C8.42578 12.906 8.67115 12.6606 8.97382 12.6606H12.6938C12.9965 12.6606 13.2418 12.906 13.2418 13.2087C13.2418 13.5114 12.9965 13.7567 12.6938 13.7567H8.97382C8.67115 13.7567 8.42578 13.5114 8.42578 13.2087Z'
					fill='currentColor'
				/>
				<path
					strokeWidth='8'
					fillRule='evenodd'
					clipRule='evenodd'
					d='M2.27836 2.59608C2.22639 2.59608 2.17655 2.61672 2.1398 2.65347C2.10305 2.69022 2.08241 2.74007 2.08241 2.79205V5.76807C2.08241 5.82005 2.10305 5.86989 2.1398 5.90664C2.17655 5.94339 2.22639 5.96404 2.27836 5.96404H5.25434C5.30631 5.96404 5.35615 5.94339 5.3929 5.90664C5.42965 5.86989 5.4503 5.82005 5.4503 5.76807V2.79205C5.4503 2.74007 5.42965 2.69022 5.3929 2.65347C5.35615 2.61672 5.30631 2.59608 5.25434 2.59608H2.27836ZM1.36475 1.87843C1.60706 1.63613 1.93569 1.5 2.27836 1.5H5.25434C5.59701 1.5 5.92565 1.63613 6.16795 1.87843C6.41025 2.12074 6.54638 2.44938 6.54638 2.79205V5.76807C6.54638 6.11074 6.41025 6.43938 6.16795 6.68168C5.92565 6.92399 5.59701 7.06012 5.25434 7.06012H2.27836C1.93569 7.06012 1.60706 6.92399 1.36475 6.68168C1.12245 6.43937 0.986328 6.11074 0.986328 5.76807V2.79205C0.986328 2.44938 1.12245 2.12074 1.36475 1.87843Z'
					fill='currentColor'
				/>
				<path
					strokeWidth='8'
					fillRule='evenodd'
					clipRule='evenodd'
					d='M2.27836 10.036C2.22639 10.036 2.17655 10.0567 2.1398 10.0934C2.10305 10.1302 2.08241 10.18 2.08241 10.232V13.208C2.08241 13.26 2.10305 13.3098 2.1398 13.3466C2.17655 13.3833 2.22639 13.404 2.27836 13.404H5.25434C5.30631 13.404 5.35615 13.3833 5.3929 13.3466C5.42965 13.3098 5.4503 13.26 5.4503 13.208V10.232C5.4503 10.18 5.42965 10.1302 5.3929 10.0934C5.35615 10.0567 5.30631 10.036 5.25434 10.036H2.27836ZM1.36475 9.31838C1.60706 9.07607 1.93569 8.93994 2.27836 8.93994H5.25434C5.59701 8.93994 5.92565 9.07607 6.16795 9.31838C6.41025 9.56068 6.54638 9.88932 6.54638 10.232V13.208C6.54638 13.5507 6.41025 13.8793 6.16795 14.1216C5.92565 14.3639 5.59701 14.5001 5.25434 14.5001H2.27836C1.93569 14.5001 1.60706 14.3639 1.36475 14.1216C1.12245 13.8793 0.986328 13.5507 0.986328 13.208V10.232C0.986328 9.88932 1.12245 9.56068 1.36475 9.31838Z'
					fill='currentColor'
				/>
			</svg>
		</span>
	);
};

export default InteractiveSideBarIcon;
